'use client';
import Link from 'next/link';
import Button from '@/components/Button';

import MarkupElement from '@/components/MarkupElement';

const heroImagefileName = 'BINGO WENDAKE 1970px x 363px.png';
const heroImagePath = '/images/' + heroImagefileName;

/**
 * Hero component.
 *
 * @component
 * @param {Object} model - The model object containing the data for the Hero component.
 * @param {string} model.welcomeMessage - The welcome message to be displayed.
 * @param {number} model.cumulatifPrix - The cumulative price to be displayed.
 * @param {string} [title=null] - The title of the Hero component. If not provided, the welcome message and cumulative price will be displayed.
 * @param {number} [tirageId=0] - The ID of the draw. Used to create the link to the purchase page.
 *
 * @returns {JSX.Element} The Hero component.
 */
const Hero = ({ model, title = null, tirageId = 0 }) => {
  /**
   * Creates a markup object from the welcome message.
   *
   * @returns {Object} An object with a __html property containing the welcome message.
   */

  return (
    <div className="hero ">
      <img className="d-none d-md-block" src={heroImagePath} alt="banderolle logo" />
      <div className="bg-lg-o-color p-2">
        {!title && (
          <>
            <div className="row g-0 justify-content-between align-items-center ">
              <div className="col-8 ps-3 grand-prize -intro text-center text-decoration-none ">
                <div>Cumulatif en prix :</div>
              </div>
              <div className={'col-4 text-center grand-prize text-decoration-none'}>
                {model?.cumulatifPrix} $
              </div>
              <div className="col-4"></div>
            </div>
            <MarkupElement markup={model?.welcomeMessage} />
            <div className="d-flex justify-content-end no-bg">
              <Button className="btn btn-outline-secondary">
                <Link className="text-dark text-decoration-none no-bg" href="/achats?tirageId=">
                  Acheter des cartes
                </Link>
              </Button>
            </div>
          </>
        )}
        {title && (
          <>
            <div className="row g-0 justify-content-center align-items-center">
              <div className="col-12 text-center ">
                <div className="title grand-prize text-decoration-none">{title}</div>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default Hero;
